var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRenameIconBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.458 15.2991L13.8099 13.6291H13.7219C13.158 14.3396 12.5757 14.8339 11.9751 15.1123C11.3818 15.3833 10.6055 15.5188 9.64601 15.5188C8.4668 15.5188 7.53663 15.1819 6.85547 14.5081C6.18164 13.8342 5.84473 12.8747 5.84473 11.6297C5.84473 10.3259 6.29883 9.36645 7.20703 8.75122C8.12256 8.12866 9.49949 7.78442 11.3379 7.7185L13.4692 7.65259V7.11425C13.4692 5.86914 12.832 5.24658 11.5576 5.24658C10.5762 5.24658 9.42263 5.54321 8.09692 6.13648L6.9873 3.87329C8.40088 3.13354 9.9683 2.76367 11.6895 2.76367C13.3374 2.76367 14.6009 3.12256 15.4797 3.84033C16.3587 4.5581 16.7981 5.64941 16.7981 7.11425V15.2991H14.458ZM13.4692 9.60819L12.1729 9.65211C11.1987 9.68136 10.4737 9.85722 9.99755 10.1794C9.52145 10.5017 9.28349 10.9924 9.28349 11.6516C9.28349 12.5965 9.82547 13.0689 10.9094 13.0689C11.6858 13.0689 12.3047 12.8455 12.7661 12.3986C13.2349 11.9519 13.4692 11.3586 13.4692 10.6189V9.60819Z",
    fill: "#556BB8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.125C0 0.50368 0.50368 0 1.125 0C1.74632 0 2.25 0.50368 2.25 1.125V16.875C2.25 17.4964 1.74632 18 1.125 18C0.50368 18 0 17.4964 0 16.875V1.125Z",
    fill: "#556BB8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRenameIconBlue);
export default __webpack_public_path__ + "static/media/rename-icon-blue.69e87a0a810129cb035b8eaf5f446e93.svg";
export { ForwardRef as ReactComponent };